// Lead-Seite in der Tiefe (Runde 7, Agent 7B): Log und Adressen, Typen und Client nach crm/API.md, Abschnitt 22.2. Feed-Suche und
// Notizen bleiben in `api/activities.ts` bzw. `api/index.ts` (additive Parameter, siehe dort).
import { http } from "./client";
import type { Aktivitaet, AktivitaetTyp, Liste } from "./types";

export interface LeadLogAenderung {
  feld: string;
  /** deutscher Name des Felds (Custom Fields mit ihrem Namen) */
  label?: string;
  alt: unknown;
  neu: unknown;
}

export interface LeadLogEintrag {
  id: number;
  zeit: string;
  nutzer_id: string | null;
  nutzer_name: string | null;
  /** z. B. lead.updated, contact.created, task.deleted, status.changed */
  art: string;
  /** deutscher Kurztitel für die Zeile */
  titel: string;
  objekt_typ: string | null;
  objekt_id: string | null;
  aenderungen: LeadLogAenderung[];
  quelle: "close" | "crm";
}

export interface LeadLogSeite {
  data: LeadLogEintrag[];
  has_more: boolean;
  cursor: string | null;
  total: number;
}

export interface AdresseEingabe {
  label?: string;
  address_1?: string | null;
  address_2?: string | null;
  city?: string | null;
  state?: string | null;
  zipcode?: string | null;
  /** ISO-3166-Alpha-2 */
  country?: string | null;
}

const k = encodeURIComponent;

/** Parameter des Verlaufs einer Lead-Seite mit Suche und Zeitraum (API.md 22.2, additiv an `GET /api/leads/{id}/activities`) */
export interface VerlaufParameter {
  types?: AktivitaetTyp[];
  custom_activity_type_id?: string;
  user_id?: string;
  contact_id?: string;
  /** Suchtext: alle Wörter müssen vorkommen, Umlaute und Groß-/Kleinschreibung egal */
  q?: string;
  /** ab Tag JJJJ-MM-TT (Berlin) */
  von?: string;
  /** bis Tag JJJJ-MM-TT einschließlich */
  bis?: string;
  limit?: number;
  cursor?: string | null;
}

export const leadTiefeApi = {
  /** Verlauf mit Suche, Nutzer, Kontakt und Zeitraum; ohne diese Zusätze wie `aktivitaetenApi.feed` */
  verlauf: (leadId: string, p: VerlaufParameter = {}, signal?: AbortSignal) =>
    http.get<Liste<Aktivitaet>>(
      `/api/leads/${k(leadId)}/activities`,
      { types: p.types, custom_activity_type_id: p.custom_activity_type_id, user_id: p.user_id, contact_id: p.contact_id, q: p.q, von: p.von, bis: p.bis, limit: p.limit, cursor: p.cursor },
      signal,
    ),
  log: (leadId: string, p: { cursor?: string | null; limit?: number; art?: string; user_id?: string; von?: string; bis?: string } = {}) =>
    http.get<LeadLogSeite>(`/api/leads/${k(leadId)}/log`, p),
  adressenSetzen: (leadId: string, adressen: AdresseEingabe[]) => http.put<{ lead: unknown }>(`/api/leads/${k(leadId)}/adressen`, { adressen }),
};
